import { useState } from "react"
    
import Swal from "sweetalert2"
import { DinamicPage, TableParams } from "../../dinamicPage/dinamyc-pages.types"
import { GET, POST } from "../../../../services/api"
import { LojaAgregador } from "../../lojas/type"
import { AggregatorPublicity } from "../../publicidade/agregador-publicity.type"
import { AggregatorClassification } from "../../AggregadorCategory/aggregadorCategory.type"
import { Post } from "../../feedRecursos"

const QUERY_DEFAULT = `?field=id&order=ASC&page=1&take=5000&search=`

export function useDashboard() {
    const [tableLoading, setTableLoading] = useState(false)
    const [lojasAgregador, setLojasAgregador] = useState<LojaAgregador[]>([])
    const [aggregatorPublicity, setAggregatorPublicity] = useState<AggregatorPublicity[]>([])
    const [aggregatorCategories, setAggregatorCategories] = useState<AggregatorClassification[]>([])
    const [posts, setPosts] = useState<Post[]>([])
    const [aggregatorDinamicPage, setAggregatorDinamicPage] = useState<DinamicPage[]>([])

    async function getLojasAgregador(params?: TableParams) {
        try {
            setTableLoading(true)

            const request = await GET(`/pluginspaceaggregator${QUERY_DEFAULT}`)
            console.log('[getAggregatorDinamicPage] Resposta da API:', request)
            if (!request.data) {
                console.warn('[getAggregatorDinamicPage] Nenhum dado retornado da API!')
            }

            setLojasAgregador(request.data)
            return request.data
        } catch (error) {
            console.log('[getLojasAgregado] Erro:', error)
            Swal.fire({
                icon: 'error',
                title: 'Erro',
                text: 'Um erro ocorreu ao filtrar',
            })
            return []
        } finally {
            setTableLoading(false)
        }
    }

    async function getAggregatorDinamicPage(params?: TableParams) {
        try {
            setTableLoading(true)

            const request = await GET(`/aggregator-dinamic-page${QUERY_DEFAULT}`)
            console.log('[getAggregatorDinamicPage] Resposta da API:', request)
            if (!request.data) {
                console.warn('[getAggregatorDinamicPage] Nenhum dado retornado da API!')
            }

            setAggregatorDinamicPage(request.data)


            return request.data
        } catch (error) {
            console.log('[getAggregatorDinamicPage] Erro:', error)
            Swal.fire({
                icon: 'error',
                title: 'Erro',
                text: 'Um erro ocorreu ao filtrar',
            })
            return []
        } finally {
            setTableLoading(false)
        }
    }

    async function getAggregatorClassification(params?: TableParams) {
        try {
            setTableLoading(true)
            const request = await GET(`/aggregator-classification${QUERY_DEFAULT}`)
            console.log('[getAggregatorClassification] Resposta da API:', request)
            if (!request.data) {
                console.warn('[getAggregatorClassification] Nenhum dado retornado da API!')
            }

            setAggregatorCategories(request.data)

            return request.data
        } catch (error) {
            console.log('[getAggregatorClassification] Erro:', error)
            Swal.fire({
                icon: 'error',
                title: 'Erro',
                text: 'Um erro ocorreu ao filtrar',
            })
            return []
        } finally {
            setTableLoading(false)
        }
    }

    async function getAggregatorPublicity(params?: TableParams) {
        try {
            setTableLoading(true)
            const request = await GET(`/aggregator-publicity/banner${QUERY_DEFAULT}`)
            const request2 = await GET(`/aggregator-publicity/highlight${QUERY_DEFAULT}`)
            console.log('[getAggregatorPublicity] Resposta da API:', request)
            if (!request.data || !request2.data) {
                console.warn('[getAggregatorPublicity] Nenhum dado retornado da API!')
            }

            setAggregatorPublicity([...request.data, ...request2.data])


            return [...request.data, ...request2.data]
        } catch (error) {
            console.log('[getAggregatorPublicity] Erro:', error)
            Swal.fire({
                icon: 'error',
                title: 'Erro',
                text: 'Um erro ocorreu ao filtrar',
            })
            return []
        } finally {
            setTableLoading(false)
        }
    }

    async function getAggregatorPosts() {
        try {
            const posts = await POST('post/filter')

            setPosts(posts.data)

        } catch (error) {
            console.log(error)
        }
    }

    return {
        getAggregatorDinamicPage,
        getLojasAgregador,
        getAggregatorClassification,
        getAggregatorPublicity,
        getAggregatorPosts,
        posts,
        aggregatorCategories,
        aggregatorPublicity,
        tableLoading,
        lojasAgregador,
        aggregatorDinamicPage,
    }

}